import BasicRequirement from '@/ship/Models/BasicRequirement';
import IncludeCall from '@/ship/Models/IncludeCall';
import {
    IncludeLaborProtectionChecklist,
    IncludeLaborProtectionAccident,
} from '@/ship/Models/Prescriptions/LaborProtection';
import IncludeViolation from '@/ship/Models/IncludeViolation';
import IncludeViolationAcceptance from '@/ship/Models/IncludeViolationAcceptance';
import IncludeViolationWarranty from '@/ship/Models/IncludeViolationWarranty';
import MainPackData from '@/ship/Models/MainPackData';
import Pagination from '@/ship/Models/Pagination';
import ViolationCount from '@/ship/Models/ViolationCount';

import GeneralViolation from '@/ship/Models/Prescriptions/GeneralViolation';
import { StoreOptions } from 'vuex';
import { namespace } from 'vuex-class';
import actions from './Actions';
import getters from './Getters';
import mutations from './Mutations';

export interface PrescriptionState {
    calls: IncludeCall[] | null;
    laborProtectionChecklists: IncludeLaborProtectionChecklist[] | null;
    laborProtectionAccidents: IncludeLaborProtectionAccident[] | null;
    laborProtectionAccidentsCount: number | null;
    lighterViolations: IncludeViolation[] | null;
    mainPackData: MainPackData | null;
    pagination: Pagination | null;
    requirements: BasicRequirement[] | null;
    violationCount: ViolationCount[] | null;
    violations: GeneralViolation[] | null;
    violationsAcceptance: IncludeViolationAcceptance[] | null;
    violationsWarranty: IncludeViolationWarranty[] | null;
}

export const state: PrescriptionState = {
    calls: null,
    laborProtectionChecklists: null,
    laborProtectionAccidents: null,
    laborProtectionAccidentsCount: null,
    lighterViolations: null,
    mainPackData: null,
    pagination: null,
    requirements: null,
    violationCount: null,
    violations: null,
    violationsAcceptance: null,
    violationsWarranty: null,
};

export const root: StoreOptions<PrescriptionState> = {
    state,
    actions,
    getters,
    mutations,
};

export const PrescriptionStore = namespace('prescription');
export const PrescriptionAction = PrescriptionStore.Action;
export const PrescriptionMutation = PrescriptionStore.Mutation;
export const PrescriptionGetter = PrescriptionStore.Getter;
export const PrescriptionState = PrescriptionStore.State;

export default root;
